import { RxkAxios } from './axios'
import globalEnv from '@/configs'
import {
  ContentTypeEnum,
  errorMessageMap,
  ResponseCodeEnum,
  ResponseStatusEnum
} from '@/enums/axios'
import { aes, decryptResponse } from '@/utils/aes'
import qs from 'qs'
import type { CreateOptions } from '@/utils/axios/axiosModel'
import { deepMerge, sleep } from '@/utils/tools'
import { getToken } from '@/utils/auth'
import { isProdMode } from '@/utils/env'
import { useAccountStore } from '@/stores/modules/account'
import { useResource } from '@/hooks/useResource'
import { isBlob, isString } from '@/utils/is'
import { getFileName } from '@/utils/util'
import { router } from '@/router'
let isNotificationShowing = false
let isHandlingInvalidSession = false
const loading: any = null
const SESSION_CHECK_URLS = [
  '/admin/user/current',
  '/admin/user/current/system',
  '/admin/user/profile/query',
  '/admin/menu/current/system',
  '/admin/menu/system/tree'
]

function isSessionCheckRequest(url = '') {
  const path = url.split('?')[0]
  return SESSION_CHECK_URLS.some(api => path === api || path.endsWith(api))
}

function isCanceledRequest(error: any) {
  return error?.code === 'ERR_CANCELED' || error?.message === 'canceled' || error?.cache
}

function handleInvalidSession() {
  if (isHandlingInvalidSession || !getToken()) return
  isHandlingInvalidSession = true
  const accountStore = useAccountStore()
  const logoutNow = () => {
    accountStore.logout(true)
    isHandlingInvalidSession = false
  }
  if (isNotificationShowing) {
    logoutNow()
    return
  }
  showErrorNotification('登录状态异常，请重新登录', logoutNow)
}
// 错误处理函数
async function showErrorNotification(errorMsg: string, fn?: Fn) {
  if (isNotificationShowing) {
    // 如果已经有通知在显示，则不显示新的通知
    return
  }

  isNotificationShowing = true // 标记通知开始显示
  // @ts-ignore
  ElNotification.error({
    title: '系统提示',
    message: errorMsg,
    showClose: false,
    duration: 1500,
    onClose: () => {
      isNotificationShowing = false // 关闭通知后取消标记
      fn?.()
    }
  })
}
const customOptions: CreateOptions = {
  baseURL: globalEnv.baseUrl || '',
  headers: { 'Content-Type': ContentTypeEnum.JSON },
  // 函数必须返回一个字符串，或 ArrayBuffer，或 Stream
  transformRequest: function (data, headers) {
    // 如果是json格式的请求头
    if (ContentTypeEnum.JSON.includes(<string>headers['Content-Type'])) {
      if (globalEnv.isNeedAes || headers?.isNeedAes) {
        return aes.encrypt(JSON.stringify(data || {}))
      } else {
        // 格式：{"uid":"cs11","pwd":"000000als","username":"cs11","password":"000000als"}
        return JSON.stringify(data || {})
      }
    }
    if (ContentTypeEnum.FORM_URLENCODED.includes(<string>headers['Content-Type'])) {
      // 格式：uid=cs11&pwd=000000als&username=cs11&password=000000als
      return qs.stringify(data || {}, { indices: false })
    }
    return data
  },
  transform: {
    /**
     * 自定义请求拦截处理
     * */
    beforeRequestHook(config, requestOptions) {
      const {
        // apiUrl = '',
        // isNeedSign,
        isJoinTimestamp,
        // urlPrefix,
        withToken
      } = requestOptions
      let loading = requestOptions.loading
      const { getMenuId, headerMenuId, headerTableCode, getMenuAppCode, headerAppCode } =
        useResource()
      const headers = config.headers || {
        'Content-type': ContentTypeEnum.FORM_URLENCODED
      }

      // const data = config.data || config.params || {}

      const headInfo = {
        timestamps: new Date().getTime()
      }
      if (isJoinTimestamp) {
        headers.timestamps = headInfo.timestamps
      }
      // headers.UserId = userInfo?.id
      if (withToken) {
        const token = getToken()
        if (token) {
          headers.Authorization = token
        }
      }
      // 数据权限需要的标识，能获取到menuId的情况下传menuId,否则传appCode
      if (!headers.MenuId) {
        if (headerTableCode.value) {
          headers.AppCode = headerTableCode.value
        } else {
          headers.MenuId = headerMenuId?.value || getMenuId()
        }
      }
      // 字段权限需要的标识
      if (getMenuAppCode() || headerAppCode?.value) {
        headers.AppCodeField = headerAppCode?.value || getMenuAppCode()
      }
      // const isJson = headers['Content-type'] === ContentTypeEnum.JSON
      // if (isNeedSign) {
      //   const tempData = isJson ? data : Object.assign(headInfo, data)
      //   headers.sign = createRequestSign(tempData, isJson, headInfo.timestamps).toUpperCase()
      // }
      // headers.tenantId = '1245752281531371520'
      config.headers = headers
      if (loading) {
        // @ts-ignore
        loading = ElLoading.service({
          lock: true,
          text: 'Loading'
        })
      }

      return config
    },
    /**
     * 自定义响应拦截处理
     * */
    afterResponseHook(response, requestOptions) {
      if (requestOptions.loading) {
        loading.close()
      }
      const { isReturnNativeResponse, showErrorMessage } = requestOptions
      // 是否要返回原生响应头
      if (isReturnNativeResponse) {
        return response
      }
      if (isBlob(response?.data)) {
        const filename = getFileName(response.headers['content-disposition'])
        console.log(filename, 'filename455556')
        if (filename) {
          console.log(response, filename, 'filename666')
          return { data: response.data, filename }
        } else {
          return new Promise((_resolve, reject) => {
            // 错误情况,返回的是json格式
            // 解密
            const fileReader = new FileReader()
            fileReader.onload = function (e) {
              const result = e.target?.result
              console.log('result', result)
              const responseData = decryptResponse(result)
              console.log('responseData', responseData)
              try {
                // this.result  = 字符串类型的 response
                //  如果接口返回的数据，非二进制的话。可以根据response做出响应的判断。
                // const fileResult = JSON.parse(result)
                const responseCopy = isString(responseData)
                  ? JSON.parse(responseData || '{}')
                  : responseData
                const msg = responseCopy.msg || ''
                msg && ElMessage.error(msg)
                console.log('fileResult', responseCopy)
                reject(responseCopy)
                //  ps：JSON.parse()是Javascript中一个常用的 JSON 转换方法，JSON.parse()可以把JSON规则的字符串转换为JSONObject 反之就会报错。
                //  如果接口内容为二进制数据。那么JSON.parse解析失败, 抛出异常来到catch进行执行下载操作
                // }
              } catch (err: any) {
                throw new Error(err)
                // 当前构造函数内的this是指向它的实例对象的。所以在外层声明了一个this用于指向全局
              }
            }
            fileReader.readAsText(response.data as unknown as Blob)
          })
        }
      }
      // 进项接口解密处理
      const responseData = decryptResponse(response?.data)
      // 接口错误时报错
      if (!responseData) {
        throw new Error('请求出错,请稍后再试')
      }
      const { code, data, msg, logMessageId } = responseData

      if (code === ResponseCodeEnum.SUCCESS) {
        return data
      } else {
        let errorMsg = msg || '服务端请求错误'
        if (code === 407) {
          const retryCount = Object.keys(data)[0]
          const retryDelayInMinutes = Object.values(data)[0]
          errorMsg = `您已连续输错${retryCount}次，请您${retryDelayInMinutes}分钟后再试`
        }
        if (!isProdMode()) {
          errorMsg += `[logMessageId：${logMessageId || ''}]`
        }
        if (showErrorMessage !== false) showErrorNotification(errorMsg)
        return Promise.reject(responseData)
        // throw new Error('请求出错,请稍后再试')
      }
    },
    /**
     * axios请求拦截器
     * */
    requestInterceptors(config) {
      return config
    },
    /**
     * axios响应拦截器
     * */
    responseInterceptors: res => {
      return res
    },
    /**
     * axios响应错误处理
     * */
    responseInterceptorsCatch: error => {
      const { response, config } = error
      const accountStore = useAccountStore()
      if (response?.status) {
        const errorInfo = errorMessageMap[response.status]
        if (errorInfo) {
          if (errorInfo.code === ResponseStatusEnum.UNAUTHORIZED) {
            showErrorNotification(errorInfo.message, () => accountStore.logout(true))
          } else if (errorInfo.code === ResponseStatusEnum.NO_LOGIN) {
            showErrorNotification(response?.data?.msg, async () => {
              const isLoginRoute = router.currentRoute.value.name === 'Login'
              if (!isLoginRoute) {
                router.push('/login')
                await sleep(2000)
                const accountStore = useAccountStore()
                accountStore.logout(false, true)
              }
            })
          } else {
            showErrorNotification(errorInfo.message)
          }
        }
      } else if (!isCanceledRequest(error) && getToken() && isSessionCheckRequest(config?.url)) {
        // CORS / 网络失败时浏览器拿不到 status，过期 token 会被显示成跨域，这里按登录态失效处理
        handleInvalidSession()
      }
      return Promise.reject(error)
    }
  },
  requestOptions: {
    apiUrl: globalEnv.baseUrl || '', // 接口地址, 由不同环境提供,相当于axios的baseUrl
    urlPrefix: globalEnv.apiPrefix, // 请求地址前缀, 由不同环境提供,
    isJoinTimestamp: true, // 是否加时间戳
    isNeedSign: true, // 是否需要签名
    // 忽略重复请求
    ignoreCancelToken: false,
    isReturnNativeResponse: false, // 是否返回原生响应头
    withToken: true // 是否加入token
  }
}

function createAxios(opt?: Partial<CreateOptions>) {
  return new RxkAxios(deepMerge(customOptions, opt))
}

const request = createAxios()

export default request
